import { useMemo, useState } from 'react';
import { IncomingCall } from '../../types';

export const useShowIncomingCallBar = ({ incomingCalls }: { incomingCalls: IncomingCall[] }) => {
  const [position, setPosition] = useState(1);
  const disabledLeftArrow = position === 1;
  const disabledRightArrow = position === incomingCalls?.length;
  const count = `${position}/${incomingCalls?.length}`;

  const latestIncomingCall = useMemo(() => {
    if (!incomingCalls || incomingCalls.length === 0) return undefined;
    if (incomingCalls.length > 1) {
      return incomingCalls[position - 1];
    } else if (incomingCalls.length === 1) {
      return incomingCalls[0];
    }

    return undefined;
  }, [incomingCalls, position]);

  return { latestIncomingCall, disabledLeftArrow, disabledRightArrow, count, setPosition };
};
